import React from 'react';
import './joinOurCommunitySection.scss';
import { ReactComponent as JoinCommunityGrid } from "./icons/JoinCommunityGrid.svg";
import { ReactComponent as GlowLeft } from "./icons/GlowLeft.svg";
import { ReactComponent as GlowCenter } from "./icons/GlowCenter.svg";
import { ReactComponent as DiscordCard } from "./icons/DiscordCard.svg";
import { ReactComponent as MailCard } from "./icons/MailCard.svg";
import { ReactComponent as TwitterCard } from "./icons/TwitterCard.svg";
import { ReactComponent as TelegramCard } from "./icons/TelegramCard.svg";

const JoinOurCommunitySection = () => {
	return (
		<div className="joinOurCommunity">
			<div className="joinOurCommunity__content">
				<div className="joinOurCommunity__content_title">
					<h3>Join our community</h3>
					<span>24/7 technical support and community</span>
				</div>
				<div className="joinOurCommunity__content_socials">
					<div className="joinOurCommunity__content_socials_glow">
						<div className="joinOurCommunity__content_socials_glow_left">
							<GlowLeft />
						</div>
						<div className="joinOurCommunity__content_socials_glow_center">
							<GlowCenter />
						</div>
					</div>
					<div className="joinOurCommunity__content_socials_cards">
						<DiscordCard onClick={() => window.open('https://discord.com/invite/hfHb3AMHRP')} />
						<MailCard onClick={() => window.open('mailto:contact@nfd.gg')} />
						<TwitterCard onClick={() => window.open('https://x.com/NFD_TradingBots')} />
						<TelegramCard onClick={() => window.open('https://t.me/NFD_Trading_Bots_Ann')} />
					</div>
					<div className="joinOurCommunity__content_socials_grid">
						<JoinCommunityGrid />
					</div>
				</div>
			</div>
		</div>
	);
};

export default JoinOurCommunitySection;